// extracted by mini-css-extract-plugin
module.exports = {"base":"sourceText_base__QenJp","title":"sourceText_title__3Qhpc","hidden":"sourceText_hidden__3c3m6","selectedTermHighlight":"sourceText_selectedTermHighlight__2SaMB"};